import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { getCachedData, setCachedData, clearCache } from "../utils/apiCache";
import {
    Container, Row, Col, Card, Button, Spinner, Modal,
    Form, Alert, Badge, ProgressBar, Pagination
} from "react-bootstrap";
import {
    FaCalendarAlt, FaUsers, FaRupeeSign, FaCheckCircle, FaTimesCircle,
    FaShieldAlt, FaDownload, FaMapMarkerAlt, FaTrophy, FaClock,
    FaUser, FaCertificate, FaArrowRight, FaMobileAlt,
    FaEnvelope, FaQrcode, FaBus, FaPrint, FaChevronLeft, FaChevronRight,
    FaExclamationTriangle, FaChevronDown, FaChevronUp, FaRedo, FaHistory
} from "react-icons/fa";
import Header from "./Header";
import { getEventBusTrackingInfo } from "../utils/eventBusTracking";
import { markEventsSeen } from "../utils/newEvents";
import { EventBusArrivingCard, EventBusContactCard } from "./EventBusTrackingPanel";
import { ProductContext } from "../context/AppContext";
import Swal from "sweetalert2";
import { KJUR } from "jsrsasign";

const Event = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clsSecId, setClsSecId] = useState(null);
    const [eventBookings, setEventBookings] = useState([]);
    const { userId, GetstudentData, Automationdata, userData } = useContext(ProductContext);
    const authtoken = localStorage.getItem("token");
    const schema = userData?.currentUser?.schema;

    console.log(GetstudentData, "GetstudentData Data");


    const studentId = GetstudentData?.id;
    const studentsession = GetstudentData?.session;
    const studentFullName = GetstudentData?.student_full_name;
    const studentEmail = GetstudentData?.contact_email;
    const studentMobileNo = GetstudentData?.contact_phone;
    const studentAdmissionNo = GetstudentData?.admission_num;

    // OTP States
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otpInput, setOtpInput] = useState('');
    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', '']);
    const [currentEventId, setCurrentEventId] = useState(null);
    const [currentFeeCategoryId, setCurrentFeeCategoryId] = useState(null);
    const [resendTimer, setResendTimer] = useState(300);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [otpLoading, setOtpLoading] = useState(false);

    // Vehicle Tracking Modal
    const [selectedVehicleUrl, setSelectedVehicleUrl] = useState('');
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false);
    const [activeVehicleBooking, setActiveVehicleBooking] = useState(null);
    const [activeVehicleEvent, setActiveVehicleEvent] = useState(null);
    const [activeVehicleBusInfo, setActiveVehicleBusInfo] = useState(null);

    // Certificate Modal
    const [showCertModal, setShowCertModal] = useState(false);
    const [certHtml, setCertHtml] = useState('');
    const [certType, setCertType] = useState(''); // 'event' or 'achievement'

    // Filter State: 'upcoming' (default), 'past', 'all'
    const [eventFilter, setEventFilter] = useState('upcoming');
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    // Event Confirmation Modal
    const [showEventConfirmModal, setShowEventConfirmModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    // Cancel Booking Modal
    const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);
    const [bookingToCancel, setBookingToCancel] = useState(null);
    const [eventToCancel, setEventToCancel] = useState(null);
    const [cancellingLoading, setCancellingLoading] = useState(false);
    const handleAgreeAndProceed = async () => {
        setShowEventConfirmModal(false);

        // Reset OTP
        setOtpDigits(['', '', '', '', '', '']);
        setOtpInput('');

        // OTP send karein
        await sendOtp();

        // OTP modal open karein
        setShowOtpModal(true);
    };

    const getNormalizedDate = (dateStr) => {
        if (!dateStr) return null;
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return null;
        d.setHours(0, 0, 0, 0);
        return d;
    };

    // API "message" is sometimes a plain string, sometimes the updated record object.
    // Only strings are safe to show in an alert - anything else renders as [object Object].
    const resolveApiMessage = (value, fallback) => {
        if (typeof value === 'string' && value.trim()) return value;
        if (value && typeof value === 'object') {
            const nested = value.message || value.error || value.detail;
            if (typeof nested === 'string' && nested.trim()) return nested;
        }
        return fallback;
    };

    const formatDateTimeDisplay = (dateStr) => {
        if (!dateStr) return '--';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        return d.toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: true
        });
    };

    const formatDateDisplay = (dateStr) => {
        if (!dateStr) return null;
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const getEventFilterDate = (event) => {
        return getNormalizedDate(event.due_date) || getNormalizedDate(event.end_date) || getNormalizedDate(event.start_date);
    };

    // Single source of truth for the Upcoming / Past / All + date-range filter,
    // applied both to the events list and to events pulled in from bookings.

    // const matchesEventFilter = (event) => {
    //     if (!event) return false;

    //     const today = new Date();
    //     today.setHours(0, 0, 0, 0);

    //     const eventDate = getEventFilterDate(event);
    //     if (!eventDate) return true;

    //     // Custom Date Range Filter
    //     if (startDateFilter || endDateFilter) {
    //         const from = startDateFilter ? getNormalizedDate(startDateFilter) : null;
    //         const to = endDateFilter ? getNormalizedDate(endDateFilter) : null;

    //         if (from && eventDate < from) return false;
    //         if (to && eventDate > to) return false;
    //         return true;
    //     }

    //     if (eventFilter === 'upcoming') {
    //         return eventDate >= today;
    //     } else if (eventFilter === 'past') {
    //         return eventDate < today;
    //     }
    //     return true;
    // };

    const matchesEventFilter = (event) => {
        if (!event) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const endDate = getNormalizedDate(event.end_date);

        if (endDate && endDate < today) {
            if (eventFilter !== "past") {
                return false;
            }
        }

        const eventDate =
            endDate ||
            getNormalizedDate(event.start_date) ||
            getNormalizedDate(event.due_date);

        if (!eventDate) return true;

        // Custom Date Range Filter
        if (startDateFilter || endDateFilter) {
            const from = startDateFilter
                ? getNormalizedDate(startDateFilter)
                : null;

            const to = endDateFilter
                ? getNormalizedDate(endDateFilter)
                : null;

            if (from && eventDate < from) return false;
            if (to && eventDate > to) return false;

            return true;
        }

        if (eventFilter === "upcoming") {
            return eventDate >= today;
        }

        if (eventFilter === "past") {
            return eventDate < today;
        }

        // All
        return true;
    };

    const filteredEvents = events.filter(matchesEventFilter);

    const isCancelledStatus = (status) => {
        const s = (status || '').toLowerCase();
        return s === 'cancelled' || s === 'canceled';
    };

    const isRejectedStatus = (status) => (status || '').toLowerCase() === 'rejected';

    // Build display items from filtered events (one card per event, cancellations grouped inside it)
    const allEventsMap = new Map();
    filteredEvents.forEach(e => {
        if (e && e.id) allEventsMap.set(Number(e.id), e);
    });

    eventBookings.forEach(b => {
        if (b && b.event_ctgry_id && b.category && !allEventsMap.has(Number(b.event_ctgry_id))) {
            // Booking-only events must respect the active filter too, otherwise a past
            // event with a cancelled booking leaks into the "Upcoming" tab.
            if (!matchesEventFilter(b.category)) return;
            allEventsMap.set(Number(b.event_ctgry_id), b.category);
        }
    });

    const combinedEvents = Array.from(allEventsMap.values());
    const allDisplayItems = [];

    combinedEvents.forEach((event) => {
        const bookingsForEvent = eventBookings.filter(
            (b) => Number(b.event_ctgry_id) === Number(event.id)
        );

        // All cancellations of the SAME event are grouped into the single event card
        // (newest cancellation first) instead of rendering one card per cancellation.
        const cancelledBookings = bookingsForEvent
            .filter((b) => isCancelledStatus(b.status))
            .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));

        // A student can apply to the same event more than once (e.g. re-apply after a
        // rejection). Every non-cancelled application gets its own card, newest first.
        const liveBookings = bookingsForEvent
            .filter((b) => !isCancelledStatus(b.status))
            .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));

        if (liveBookings.length === 0) {
            allDisplayItems.push({
                keyId: `event_${event.id}`,
                event: event,
                booking: undefined,
                cancelledBookings
            });
            return;
        }

        liveBookings.forEach((booking, idx) => {
            allDisplayItems.push({
                keyId: `event_${event.id}_booking_${booking.id}`,
                event: event,
                booking,
                // Cancellation history is shown once, on the newest application's card
                cancelledBookings: idx === 0 ? cancelledBookings : []
            });
        });
    });

    // How many times the event in the confirmation modal was previously cancelled
    const selectedEventCancelCount = selectedEvent
        ? eventBookings.filter(
            (b) => Number(b.event_ctgry_id) === Number(selectedEvent.id) && isCancelledStatus(b.status)
        ).length
        : 0;

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(8);

    useEffect(() => {
        setCurrentPage(1);
    }, [eventFilter, startDateFilter, endDateFilter]);

    const totalPages = Math.ceil(allDisplayItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentDisplayItems = allDisplayItems.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisiblePages = 5;
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    useEffect(() => {
        if (userId) {
            fetchStudentId();
        }
    }, [userId]);

    const fetchStudentId = async () => {
        try {
            const response = await fetch(`https://api.mirai.healthcare/api/student?regs_id=${userId}`, {
                headers: { "x-auth": authtoken }
            });
            const data = await response.json();
            if (data.success && data.message.length > 0) {
                setClsSecId(data.message[0].class_section_id);
            }
        } catch (error) {
            console.error("Error fetching student data:", error);
        }
    };

    useEffect(() => {
        if (studentId && clsSecId) {
            fetchEventData();
            fetchEventBookings();
        }
    }, [studentId, clsSecId]);

    const fetchEventData = async () => {
        if (!studentId || !clsSecId) return;
        const cacheKey = `events_${studentId}_${clsSecId}`;
        const cached = getCachedData(cacheKey);
        if (cached) {
            setEvents(cached);
            markEventsSeen(studentId, cached);
            setLoading(false);
        }
        try {
            setLoading(true);
            const response = await axios.get(
                `https://api.mirai.healthcare/api/student-details/event-ctgry/student?student_id=${studentId}&cls_sec_id=${clsSecId}`,
                { headers: { "x-auth": authtoken } }
            );
            if (response.data.success) {
                const data = response.data.message || [];
                setEvents(data);
                setCachedData(cacheKey, data);
                // Parent has now seen these - clears the "new event" blink on the dashboard tab.
                markEventsSeen(studentId, data);
            }
        } catch (error) {
            console.error("Error fetching event data:", error);
            Swal.fire({
                title: "Error",
                text: "Failed to load events.",
                icon: "error",
                confirmButtonColor: "#3085d6"
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchEventBookings = async () => {
        if (!studentId) return;
        const cacheKey = `event_bookings_${studentId}`;
        const cached = getCachedData(cacheKey);
        if (cached) {
            setEventBookings(cached);
        }
        try {
            const response = await axios.get(
                `https://api.mirai.healthcare/api/student-details/event-booking/student?student_id=${studentId}`,
                { headers: { "x-auth": authtoken } }
            );
            const data = response.data.message || [];
            setEventBookings(data);
            setCachedData(cacheKey, data);
        } catch (error) {
            console.error("Error fetching bookings:", error);
        }
    };

    const handleApply = async (eventId, feeCategoryId) => {
        try {
            const payload = {
                session_id: Number(studentsession),
                cls_sec_id: clsSecId,
                status: "Pending",
                event_ctgry_id: eventId,
                fee_category_id: feeCategoryId,
                student_id: studentId,

            };
            const response = await axios.post(
                "https://api.mirai.healthcare/api/student-details/event-booking",
                payload,
                { headers: { "x-auth": authtoken } }
            );
            if (response.data.success) {
                clearCache(`events_${studentId}_${clsSecId}`);
                clearCache(`event_bookings_${studentId}`);
                Swal.fire({
                    title: "Success!",
                    text: "Event booked successfully!",
                    icon: "success",
                    confirmButtonColor: "#3085d6"
                });
                fetchEventData();
                fetchEventBookings();
                setShowOtpModal(false);
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Failed to book the event.",
                    icon: "error",
                    confirmButtonColor: "#3085d6"
                });
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: resolveApiMessage(error.response?.data?.message, "Failed to book."),
                icon: "error",
                confirmButtonColor: "#3085d6"
            });
        }
    };

    const initiateCancelBooking = (booking, event) => {
        const isPending = booking?.status === 'Pending';
        const isUnpaid = getEventPaidStatus(event, booking) !== 'paid';

        if (!isPending || !isUnpaid) {
            Swal.fire({
                title: "Action Not Allowed",
                text: "Only pending and unpaid event bookings can be cancelled.",
                icon: "warning",
                confirmButtonColor: "#3085d6"
            });
            return;
        }

        const bookingId = booking?.id || booking?.event_booking_id || booking?.booking_id;
        if (!bookingId) {
            Swal.fire({
                title: "Error",
                text: "Invalid booking ID.",
                icon: "error",
                confirmButtonColor: "#3085d6"
            });
            return;
        }

        setBookingToCancel(booking);
        setEventToCancel(event);
        setShowCancelConfirmModal(true);
    };

    const confirmCancelBooking = async () => {
        if (!bookingToCancel) return;
        const bookingId = bookingToCancel?.id || bookingToCancel?.event_booking_id || bookingToCancel?.booking_id;

        try {
            setCancellingLoading(true);
            const response = await axios.put(
                `https://api.mirai.healthcare/api/student-details/event-booking/cancel/${bookingId}`,
                {},
                {
                    headers: {
                        "x-auth": authtoken,
                        "Content-Type": "application/json"
                    }
                }
            );

            setShowCancelConfirmModal(false);
            setCancellingLoading(false);

            if (response.data.success || response.data.status) {
                clearCache(`events_${studentId}_${clsSecId}`);
                clearCache(`event_bookings_${studentId}`);
                Swal.fire({
                    title: "Cancelled!",
                    text: resolveApiMessage(response.data.message, "Event booking cancelled successfully."),
                    icon: "success",
                    confirmButtonColor: "#3085d6"
                });
                fetchEventData();
                fetchEventBookings();
            } else {
                Swal.fire({
                    title: "Error",
                    text: resolveApiMessage(response.data.message, "Failed to cancel event booking."),
                    icon: "error",
                    confirmButtonColor: "#3085d6"
                });
            }
        } catch (error) {
            console.error("Error cancelling booking:", error);
            setCancellingLoading(false);
            setShowCancelConfirmModal(false);
            Swal.fire({
                title: "Error",
                text: resolveApiMessage(error.response?.data?.message, "Failed to cancel event booking."),
                icon: "error",
                confirmButtonColor: "#3085d6"
            });
        }
    };

    useEffect(() => {
        let timer;
        if (isResendDisabled && resendTimer > 0) {
            timer = setTimeout(() => setResendTimer(prev => prev - 1), 1000);
        } else if (resendTimer === 0) {
            setIsResendDisabled(false);
        }
        return () => clearTimeout(timer);
    }, [resendTimer, isResendDisabled]);

    const formatTimer = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    const handleOtpDigitChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;

        if (value.length > 1) {
            const digits = value.slice(0, 6).split('');
            const newOtp = [...digits, ...Array(6 - digits.length).fill('')].slice(0, 6);
            setOtpDigits(newOtp);
            setOtpInput(newOtp.join(''));
            const focusIdx = Math.min(digits.length, 5);
            document.getElementById(`otp-input-${focusIdx}`)?.focus();
            return;
        }

        const newOtp = [...otpDigits];
        newOtp[index] = value;
        setOtpDigits(newOtp);
        setOtpInput(newOtp.join(''));

        if (value && index < 5) {
            document.getElementById(`otp-input-${index + 1}`)?.focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            if (!otpDigits[index] && index > 0) {
                document.getElementById(`otp-input-${index - 1}`)?.focus();
            }
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim().slice(0, 6);
        if (/^\d+$/.test(pastedData)) {
            const digits = pastedData.split('');
            const newOtp = [...digits, ...Array(6 - digits.length).fill('')].slice(0, 6);
            setOtpDigits(newOtp);
            setOtpInput(newOtp.join(''));
            const focusIdx = Math.min(digits.length, 5);
            document.getElementById(`otp-input-${focusIdx}`)?.focus();
        }
    };

    const [otpUuid, setOtpUuid] = useState("");

    const sendOtp = async () => {
        try {
            const mobileNo = studentAdmissionNo;

            const response = await axios.post(
                `https://api.mirai.healthcare/api/student/event/otp-send`,
                {
                    admission_no: studentAdmissionNo,
                },
                {
                    headers: {
                        "x-auth": authtoken
                    }
                }
            );

            console.log("Send OTP Response:", response.data);

            // API response se UUID save karein
            const uuid = response?.data?.message?.data?.uuid;
            if (!uuid) {
                throw new Error("OTP UUID not received from API.");
            }

            setOtpUuid(uuid);

            Swal.fire({
                title: "OTP Sent!",
                text: "6-digit OTP has been sent to your mobile number.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            setResendTimer(300);
            setIsResendDisabled(true);

        } catch (error) {
            console.error("Send OTP Error:", error);
        }
    };

    const verifyOtp = async () => {
        const fullOtp = otpDigits.join('') || otpInput;

        if (fullOtp.length !== 6) {
            Swal.fire({
                title: "Invalid OTP",
                text: "Please enter full 6-digit OTP code.",
                icon: "warning",
                confirmButtonColor: "#3085d6"
            });
            return;
        }

        setOtpLoading(true);

        try {
            const response = await axios.post(
                "https://api.mirai.healthcare/api/student/event/verify-otp",
                {
                    admission_no: studentAdmissionNo,
                    otp: parseInt(fullOtp, 10),

                },
                {
                    headers: {
                        "x-auth": authtoken
                    }
                }
            );

            console.log("Verify OTP Response:", response.data);

            const resData = response.data;

            const isVerified =
                resData?.success === true &&
                resData?.message === "OTP verified successfully";

            if (isVerified) {
                console.log("OTP VERIFIED SUCCESSFULLY");

                await handleApply(
                    currentEventId,
                    currentFeeCategoryId
                );

            } else {
                const errorMsg = resolveApiMessage(
                    resData?.message,
                    "OTP verification failed. Please try again."
                );

                Swal.fire({
                    title: "OTP Verification Failed",
                    text: errorMsg,
                    icon: "error",
                    confirmButtonColor: "#3085d6"
                });
            }

        } catch (error) {
            console.error("OTP Verification Error:", error);
            console.error("API Error Response:", error.response?.data);

            const errDetail = resolveApiMessage(
                error.response?.data?.message,
                "Invalid OTP. Please try again."
            );

            Swal.fire({
                title: "Invalid OTP",
                text: errDetail,
                icon: "error",
                confirmButtonColor: "#3085d6"
            });

        } finally {
            setOtpLoading(false);
        }
    };

    const generateJwtToken = (schema) => {
        const header = { alg: "HS256", typ: "JWT" };
        const payload = {
            schema: schema,
            exp: Math.floor(Date.now() / 1000) + (30 * 60),
        };
        const sHeader = JSON.stringify(header);
        const sPayload = JSON.stringify(payload);
        return KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
    };

    const generatePaymentToken = (paymentData) => {
        const header = { alg: "HS256", typ: "JWT" };
        const payload = {
            paymentData,
            exp: Math.floor(Date.now() / 1000) + (10 * 60),
        };
        const sHeader = JSON.stringify(header);
        const sPayload = JSON.stringify(payload);
        return KJUR.jws.JWS.sign("HS256", sHeader, sPayload, "token");
    };

    const getEventPayAmount = (event) => {
        const activeIncrements = (event.fee_increment || []).filter(inc => inc.status === "Active");
        if (activeIncrements.length > 0) {
            return activeIncrements.reduce((sum, inc) => sum + parseFloat(inc.amount || 0), 0);
        }
        return parseFloat(event.pay_amount || 0);
    };

    // Approved discounts on this booking (is_incre=false) are deducted from the event fee
    const getEventDiscountAmount = (booking) =>
        (booking?.eventDiscount || [])
            .filter((d) => d.status === "Approved" && !d.is_incre)
            .reduce((sum, d) => sum + parseFloat(d.amount || 0), 0);

    const getEventRemainingAmount = (event, booking) => {
        const increments = event.fee_increment || booking?.fee_increment || booking?.category?.fee_increment || [];
        const activeIncrements = increments.filter(inc => inc.status === "Active");

        const totalPayAmount = activeIncrements.length > 0
            ? activeIncrements.reduce((sum, inc) => sum + parseFloat(inc.amount || 0), 0)
            : parseFloat(event.pay_amount || booking?.category?.pay_amount || 0);
        const netPayAmount = Math.max(totalPayAmount - getEventDiscountAmount(booking), 0);

        const collections = event.fee_collection || booking?.fee_collection || booking?.category?.fee_collection || [];
        const totalPaidFromColl = collections.reduce((sum, coll) => sum + parseFloat(coll.amount_paid || 0), 0);

        return Math.max(netPayAmount - totalPaidFromColl, 0);
    };

    const getEventPaidStatus = (event, booking) => {
        const increments = event?.fee_increment || booking?.fee_increment || booking?.category?.fee_increment || [];
        const activeIncrements = increments.filter(inc => inc.status === "Active");
        const grossPayAmount = activeIncrements.length > 0
            ? activeIncrements.reduce((sum, inc) => sum + parseFloat(inc.amount || 0), 0)
            : parseFloat(event?.pay_amount || booking?.category?.pay_amount || 0);
        const totalPayAmount = Math.max(grossPayAmount - getEventDiscountAmount(booking), 0);

        if (totalPayAmount <= 0) {
            return "paid";
        }

        const collections = event?.fee_collection || booking?.fee_collection || booking?.category?.fee_collection || [];
        const totalPaidFromColl = collections.reduce((sum, coll) => sum + parseFloat(coll.amount_paid || 0), 0);

        const isPaid = (collections.length > 0)
            ? (collections.some(coll => parseFloat(coll.amount_balanced || 0) === 0) || totalPaidFromColl >= totalPayAmount)
            : (booking?.paid_status?.toLowerCase() === 'paid');

        return isPaid ? "paid" : "unpaid";
    };

    const [expandedDesc, setExpandedDesc] = useState(null);
    const [expandedHistory, setExpandedHistory] = useState(null);
    // How many cancellation entries are visible per card (keyed by card id)
    const HISTORY_PAGE_SIZE = 3;
    const [historyVisibleCount, setHistoryVisibleCount] = useState({});

    // Audit trail per booking, fetched lazily when its card's history is opened
    const [expandedAudit, setExpandedAudit] = useState(null);
    const [bookingAudits, setBookingAudits] = useState({});

    const fetchBookingAudits = async (bookingId) => {
        setBookingAudits((prev) => ({ ...prev, [bookingId]: { loading: true, data: prev[bookingId]?.data || [] } }));
        try {
            const response = await axios.get(
                `https://api.mirai.healthcare/api/student-details/event-booking/${bookingId}`,
                { headers: { "x-auth": authtoken } }
            );
            const audits = [...(response.data?.message?.audits || [])]
                .sort((a, b) => new Date(b.action_at || 0) - new Date(a.action_at || 0));
            setBookingAudits((prev) => ({ ...prev, [bookingId]: { loading: false, data: audits } }));
        } catch (error) {
            console.error("Error fetching booking history:", error);
            setBookingAudits((prev) => ({ ...prev, [bookingId]: { loading: false, data: [], error: true } }));
        }
    };

    const toggleBookingAudit = (keyId, bookingId) => {
        if (expandedAudit === keyId) {
            setExpandedAudit(null);
            return;
        }
        setExpandedAudit(keyId);
        fetchBookingAudits(bookingId);
    };

    const describeAudit = (audit) => {
        if (audit.action_type === 'CREATE') return { label: 'Applied for event', variant: 'primary' };
        switch (audit.updated_field) {
            case 'status':
                return { label: `Status changed to ${audit.status}`, variant: getStatusVariant(audit.status) };
            case 'paid_status':
                return { label: `Payment marked ${audit.paid_status}`, variant: getPaymentVariant((audit.paid_status || "").toLowerCase()) };
            case 'is_active':
                return audit.is_active
                    ? { label: 'Application activated', variant: 'success' }
                    : { label: 'Application deactivated', variant: 'secondary' };
            case 'is_published':
                return { label: audit.is_published ? 'Published' : 'Unpublished', variant: 'info' };
            case 'is_deleted':
                return { label: 'Application removed', variant: 'danger' };
            default:
                return { label: audit.updated_field ? `${audit.updated_field.replace(/_/g, ' ')} updated` : 'Updated', variant: 'secondary' };
        }
    };

    const handlePayNow = async (event, booking) => {
        try {
            const totalAmount = getEventRemainingAmount(event, booking);
            const feeCategoryObj = event.fee_categories || {};
            const feeCategoryId = feeCategoryObj.id;
            const feeCycleId = booking.student?.fee_cycle_id || GetstudentData?.fee_cycle_id || localStorage.getItem('fee_cycle_id') || 1;
            const activeIncrements = (event.fee_increment || []).filter(inc => inc.status === "Active");
            const feeMonth = activeIncrements[0]?.month || (new Date().getMonth() + 1);

            const feeCollItem = {
                session_id: Number(studentsession),
                student_id: Number(studentId),
                class_section_id: clsSecId,
                stream_id: GetstudentData?.stream_id || GetstudentData?.cls_sec?.stream_id || 1,
                fee_category_id: feeCategoryId,
                fee_cycle_id: String(feeCycleId),
                amount_due: totalAmount,
                amount_paid: totalAmount,
                amt_paid: totalAmount,
                amount_balanced: 0,
                payment_mode: Automationdata?.data?.[0]?.PaymentMethod === "SabPaisa" ? "SabPaisa" : "Payu",
                payment_date: new Date().toISOString().split("T")[0],
                fee_month: feeMonth,
            };

            const payload = {
                session_id: Number(studentsession),
                class_section_id: clsSecId,
                student_id: Number(studentId),
                payment_mode: Automationdata?.data?.[0]?.PaymentMethod === "SabPaisa" ? "SabPaisa" : "Payu",
                amount: totalAmount,
                submission_date: new Date().toISOString().split("T")[0],
                fee_coll: [feeCollItem],
            };

            const jwtToken = generateJwtToken(schema);

            Swal.fire({
                title: "Processing...",
                text: "Please wait while we initiate the payment collection.",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await axios.post(
                "https://api.mirai.healthcare/api/fee-service/fee-collections",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth": jwtToken,
                    }
                }
            );

            const responseData = response.data;
            console.log("Fee Collections Response:", responseData);

            if (responseData.status && Array.isArray(responseData.data) && Array.isArray(responseData.data[0])) {
                if (parseFloat(totalAmount) <= 0) {
                    clearCache(`events_${studentId}_${clsSecId}`);
                    clearCache(`event_bookings_${studentId}`);
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Registration & fee collection completed successfully!",
                        confirmButtonColor: "#3085d6"
                    });
                    fetchEventData();
                    fetchEventBookings();
                    return;
                }

                const feeCollectionIds = responseData.data[0].map(item => item.id);
                const feeCollHeaderIds = [
                    ...new Set(
                        responseData.data[0]
                            .map(item => item.fee_coll_header_id)
                            .filter(id => id !== null && id !== undefined)
                    ),
                ];

                const payuJwtToken = generateJwtToken(schema);

                const eventBookingId = booking?.id || booking?.event_booking_id || booking?.booking_id || "";

                const securePaymentPayload = {
                    amount: totalAmount.toString(),
                    productinfo: "Fee Collection",
                    firstname: studentFullName || "",
                    email: studentEmail || "default@example.com",
                    phone: studentMobileNo || "0000000000",
                    authToken: payuJwtToken,
                    sessionId: payload.session_id.toString(),
                    classSectionId: payload.class_section_id.toString(),
                    feeCollectionIds,
                    feeCollHeaderIds,
                    paymentMethod: Automationdata?.data?.[0]?.PaymentMethod || "PayU",
                    eventBookingId: eventBookingId,
                };

                const paymentToken = generatePaymentToken(securePaymentPayload);
                const paymentUrl = `${window.location.origin}/pay-u-payment?paymentToken=${encodeURIComponent(paymentToken)}${eventBookingId ? `&eventBookingId=${eventBookingId}` : ''}`;

                Swal.fire({
                    icon: "success",
                    title: "Payment Initiated",
                    text: `Redirecting to payment for amount ₹${totalAmount}.`,
                    showConfirmButton: false,
                    timer: 1500,
                });

                window.location.href = paymentUrl;
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: responseData.message || "Failed to initiate payment collection.",
                    confirmButtonColor: "#3085d6"
                });
            }
        } catch (error) {
            console.error("Payment initiation error:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: resolveApiMessage(error.response?.data?.message, "Failed to contact fee collection service."),
                confirmButtonColor: "#3085d6"
            });
        }
    };

    const isTrackingTimeAllowed = (booking, event) => {
        const startStr = booking?.category?.start_date || event?.start_date;
        const endStr = booking?.category?.end_date || event?.end_date || booking?.category?.due_date || event?.due_date;

        if (!startStr && !endStr) return true;

        const now = new Date();

        let startDate = startStr ? new Date(startStr) : null;
        if (startDate) startDate.setHours(0, 0, 0, 0);

        let endDate = endStr ? new Date(endStr) : null;
        if (endDate) endDate.setHours(23, 59, 59, 999);

        if (startDate && now < startDate) return false;
        if (endDate && now > endDate) return false;

        return true;
    };

    const handleVehicleTrack = (booking, event) => {
        // A substitute assigned for today replaces the regular bus, so it is the
        // one tracked (and contacted) by default.
        const busInfo = getEventBusTrackingInfo(booking, event);
        setActiveVehicleBusInfo(busInfo);
        setVehicleOptions(busInfo.vehicleOptions);
        setSelectedVehicleUrl(busInfo.activeTrackUrl || '');
        setActiveVehicleBooking(booking);
        setActiveVehicleEvent(event);
        setIsVehicleModalOpen(true);
    };

    const handleCloseVehicleView = () => {
        setIsVehicleModalOpen(false);
        setActiveVehicleBooking(null);
        setActiveVehicleEvent(null);
        setActiveVehicleBusInfo(null);
        setSelectedVehicleUrl('');
        setVehicleOptions([]);
    };

    const handleCertificate = async (eventId, type) => {
        try {
            setCertType(type);
            const payload = {
                userType: 'student',
                documentType: type === 'event' ? 'event_participate' : 'achievement_certificate',
                studentId: studentId,
                session_id: studentsession,
                data: { eventId, issueDate: new Date().toISOString().split('T')[0] }
            };
            const response = await axios.post(
                `https://api.mirai.healthcare/api/head/diary/document/event-participation-certificate`,
                payload,
                { headers: { "x-auth": authtoken }, responseType: 'text' }
            );
            setCertHtml(response.data);
            setShowCertModal(true);
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Failed to generate certificate.",
                icon: "error",
                confirmButtonColor: "#3085d6"
            });
        }
    };

    const printCertificate = () => {
        let iframe = document.getElementById('cert-print-frame');
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = 'cert-print-frame';
            iframe.style.position = 'fixed';
            iframe.style.right = '0';
            iframe.style.bottom = '0';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = '0';
            document.body.appendChild(iframe);
        }
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(certHtml);
        doc.close();
        setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }, 300);
    };

    const getBookingForEvent = (eventId) => eventBookings.find(b => b.event_ctgry_id === eventId);

    const getStatusVariant = (status) => {
        switch (status) {
            case 'Approved': return 'success';
            case 'Pending': return 'warning';
            case 'Rejected': return 'danger';
            case 'Cancelled': return 'danger';
            case 'canceled': return 'danger';
            default: return 'secondary';
        }
    };

    const getPaymentVariant = (paidStatus) => {
        return paidStatus === 'paid' ? 'success' : 'warning';
    };

    if (loading) {
        return (
            <div className="page-wrapper min-vh-100 bg-white">
                <Header />
                <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: '50vh' }}>
                    <div className="text-center">
                        <Spinner animation="border" variant="primary" size="lg" className="mb-3" />
                        <p className="text-muted">Loading events...</p>
                    </div>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-wrapper min-vh-100 bg-white">
            <Header />
            {/* Header Section */}
            <div className="bg-light border-bottom py-3 mt-3">
                <Container fluid>
                    <Row className="align-items-center justify-content-between g-3">

                        <Col xs={12} lg={4} className="d-flex align-items-center gap-2">
                            <FaCalendarAlt className="text-primary fs-4" />
                            <div>
                                <h2
                                    className="page-title fw-bold mb-0"
                                    style={{ letterSpacing: "0.5px" }}>Events & Activities</h2>
                                <small className="text-muted">Participate in exciting school events and activities</small>
                            </div>
                        </Col>

                        <Col xs={12} lg={8} className="d-flex align-items-center justify-content-lg-end gap-2 flex-wrap">
                            {/* Preset Filter Buttons */}
                            <div className="btn-group shadow-sm me-lg-1" role="group" aria-label="Event Filter">
                                <Button
                                    variant={eventFilter === 'upcoming' && !startDateFilter && !endDateFilter ? 'primary' : 'outline-primary'}
                                    size="sm"
                                    onClick={() => {
                                        setEventFilter('upcoming');
                                        setStartDateFilter('');
                                        setEndDateFilter('');
                                    }}
                                    className="px-3"
                                >
                                    Upcoming
                                </Button>
                                <Button
                                    variant={eventFilter === 'past' && !startDateFilter && !endDateFilter ? 'primary' : 'outline-primary'}
                                    size="sm"
                                    onClick={() => {
                                        setEventFilter('past');
                                        setStartDateFilter('');
                                        setEndDateFilter('');
                                    }}
                                    className="px-3"
                                >
                                    Past
                                </Button>
                                <Button
                                    variant={eventFilter === 'all' && !startDateFilter && !endDateFilter ? 'primary' : 'outline-primary'}
                                    size="sm"
                                    onClick={() => {
                                        setEventFilter('all');
                                        setStartDateFilter('');
                                        setEndDateFilter('');
                                    }}
                                    className="px-3"
                                >
                                    All
                                </Button>
                            </div>

                            {/* Custom Date Range Filter Inputs */}
                            <div className="d-flex align-items-center gap-2 bg-white p-1 rounded border shadow-sm flex-wrap">
                                <Form.Group className="mb-0 d-flex align-items-center gap-1">
                                    <Form.Label className="small text-muted mb-0 px-1 fw-semibold">From:</Form.Label>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={startDateFilter}
                                        onChange={(e) => setStartDateFilter(e.target.value)}
                                        style={{ width: '135px' }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-0 d-flex align-items-center gap-1">
                                    <Form.Label className="small text-muted mb-0 px-1 fw-semibold">To:</Form.Label>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={endDateFilter}
                                        onChange={(e) => setEndDateFilter(e.target.value)}
                                        style={{ width: '135px' }}
                                    />
                                </Form.Group>

                                {(startDateFilter || endDateFilter) && (
                                    <Button
                                        variant="link"
                                        size="sm"
                                        className="text-danger p-0 px-1 text-decoration-none fw-semibold"
                                        onClick={() => {
                                            setStartDateFilter('');
                                            setEndDateFilter('');
                                        }}
                                        title="Reset date filter"
                                    >
                                        Reset
                                    </Button>
                                )}
                            </div>

                            <Badge bg="primary" className="px-3 py-2 ms-lg-2">
                                {filteredEvents.length} Events
                            </Badge>
                        </Col>

                    </Row>
                </Container>
            </div>


            <Container fluid className="py-4">
                {allDisplayItems.length > 0 ? (
                    <>
                        <Row className="g-4">
                            {currentDisplayItems.map((item) => {
                                const { keyId, event, booking, cancelledBookings = [] } = item;
                                const isBookingActive = !!booking;
                                const isRejected = isBookingActive && isRejectedStatus(booking.status);
                                const cancelCount = cancelledBookings.length;
                                const hasCancelHistory = cancelCount > 0;
                                const isHistoryOpen = expandedHistory === keyId;
                                const visibleHistoryCount = historyVisibleCount[keyId] || HISTORY_PAGE_SIZE;
                                const visibleCancelledBookings = cancelledBookings.slice(0, visibleHistoryCount);
                                const remainingHistoryCount = cancelCount - visibleCancelledBookings.length;
                                const busInfo = isBookingActive ? getEventBusTrackingInfo(booking, event) : null;
                                const vehicleUrl = busInfo?.activeTrackUrl;
                                const progressPercentage = (event.booked_count / event.capacity) * 100;

                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const dueDate = getNormalizedDate(event.due_date);
                                const isDuePassed = dueDate ? (today > dueDate) : false;

                                const endDate = getNormalizedDate(event.end_date);
                                const isEndDatePassed = endDate ? today > endDate : false;
                                const isRegistrationClosed = isDuePassed || isEndDatePassed;

                                return (
                                    <Col xs={12} md={6} lg={3} key={keyId} className="d-flex">
                                        <Card
                                            className={`w-100 shadow-sm h-100 hover-lift ${isRejected ? 'border border-2 border-danger' : 'border-0'}`}
                                            style={{ borderRadius: '16px', ...(isRejected ? { background: '#fff5f5' } : {}) }}
                                        >
                                            {/* Event Image */}
                                            <div className="position-relative">
                                                <Card.Img
                                                    variant="top"
                                                    src={event.url?.link || "/api/placeholder/400/200"}
                                                    style={{
                                                        height: "200px",
                                                        objectFit: "cover",
                                                        borderTopLeftRadius: "16px",
                                                        borderTopRightRadius: "16px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                        if (event.url?.link) {
                                                            setSelectedImage(event.url.link);
                                                            setShowImageModal(true);
                                                        }
                                                    }}
                                                    onError={(e) => {
                                                        e.target.src =
                                                            "https://via.placeholder.com/400x200/f8f9fa/6c757d?text=Event+Image";
                                                    }}
                                                />
                                                {isBookingActive && !isRejected && getEventPaidStatus(event, booking) !== 'paid' ? (
                                                    <Badge
                                                        bg="dark"
                                                        className="position-absolute top-0 end-0 m-3 px-3 py-2"
                                                    >
                                                        <FaRupeeSign className="me-1" />
                                                        {getEventRemainingAmount(event, booking)}
                                                    </Badge>
                                                ) : !isBookingActive && getEventPayAmount(event) > 0 ? (
                                                    <Badge
                                                        bg="dark"
                                                        className="position-absolute top-0 end-0 m-3 px-3 py-2"
                                                    >
                                                        <FaRupeeSign className="me-1" />
                                                        {getEventPayAmount(event)}
                                                    </Badge>
                                                ) : null}

                                                {/* Rejected ribbon */}
                                                {isRejected && (
                                                    <Badge
                                                        bg="danger"
                                                        className="position-absolute top-0 start-0 m-3 px-3 py-2 d-flex align-items-center gap-1"
                                                    >
                                                        <FaTimesCircle />
                                                        Rejected
                                                    </Badge>
                                                )}

                                                {/* Cancelled ribbon - shows how many times this event was cancelled */}
                                                {hasCancelHistory && !isBookingActive && (
                                                    <Badge
                                                        bg="danger"
                                                        className="position-absolute top-0 start-0 m-3 px-3 py-2 d-flex align-items-center gap-1"
                                                    >
                                                        <FaTimesCircle />
                                                        {cancelCount > 1 ? `Cancelled ${cancelCount} times` : 'Cancelled'}
                                                    </Badge>
                                                )}
                                            </div>

                                            <Card.Body className="d-flex flex-column p-4">
                                                {/* Event Title & Description */}
                                                <div className="flex-grow-1">

                                                    {/* Title */}
                                                    <h6 className="fw-semibold mb-1 text-dark text-truncate" title={event.title}>
                                                        {event.title}
                                                    </h6>

                                                    <div>
                                                        <p
                                                            className="text-muted small mb-1"
                                                            style={
                                                                expandedDesc !== keyId
                                                                    ? {
                                                                        display: "-webkit-box",
                                                                        WebkitLineClamp: 2,
                                                                        WebkitBoxOrient: "vertical",
                                                                        overflow: "hidden",
                                                                    }
                                                                    : {}
                                                            }
                                                        >
                                                            {event.descp || "No description available"}
                                                        </p>

                                                        {event.descp && event.descp.length > 100 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-link btn-sm p-0 text-decoration-none"
                                                                onClick={() =>
                                                                    setExpandedDesc(
                                                                        expandedDesc === keyId ? null : keyId
                                                                    )
                                                                }
                                                            >
                                                                {expandedDesc === keyId ? "View Less" : "View More"}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Event Details */}
                                                <div className="mb-3">
                                                    {/* Start & End Date */}
                                                    {(event.start_date || event.end_date) && (
                                                        <div className="text-muted small mb-2 d-flex align-items-center gap-1">
                                                            <FaCalendarAlt className="text-primary flex-shrink-0" />
                                                            <span>
                                                                <strong>Date:</strong> {formatDateDisplay(event.start_date)}
                                                                {event.end_date && event.end_date !== event.start_date
                                                                    ? ` - ${formatDateDisplay(event.end_date)}`
                                                                    : ''}
                                                            </span>
                                                        </div>
                                                    )}

                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <small className="text-muted d-flex align-items-center gap-1">
                                                            <FaUsers />
                                                            {event.booked_count}/{event.capacity} booked
                                                        </small>
                                                        {(event.due_date || event.end_date) && (
                                                            <small
                                                                className={`d-flex align-items-center gap-1 ${isRegistrationClosed
                                                                    ? 'text-danger fw-semibold'
                                                                    : isBookingActive ? 'text-muted' : 'text-primary fw-semibold'}`}
                                                            >
                                                                <FaClock />
                                                                {isRegistrationClosed ? 'Registration Closed On: ' : 'Last Date to Apply: '}{formatDateDisplay(event.due_date || event.end_date)}
                                                            </small>
                                                        )}
                                                    </div>

                                                    <ProgressBar
                                                        now={progressPercentage}
                                                        variant={progressPercentage >= 90 ? "danger" : progressPercentage >= 70 ? "warning" : "success"}
                                                        className="rounded-pill"
                                                        style={{ height: '6px' }}
                                                    />
                                                </div>

                                                {/* Cancellation history - every cancellation of this event, grouped */}
                                                {hasCancelHistory && (
                                                    <div
                                                        className="mb-3 rounded-3 border"
                                                        style={{ borderColor: '#f5c2c7', background: '#fff8f8' }}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="btn btn-link w-100 text-decoration-none d-flex align-items-center justify-content-between gap-2 px-3 py-2"
                                                            onClick={() => {
                                                                setExpandedHistory(isHistoryOpen ? null : keyId);
                                                                setHistoryVisibleCount((prev) => ({
                                                                    ...prev,
                                                                    [keyId]: HISTORY_PAGE_SIZE
                                                                }));
                                                            }}
                                                            aria-expanded={isHistoryOpen}
                                                        >
                                                            <span className="d-flex align-items-center gap-2 text-danger small fw-semibold">
                                                                <FaHistory />
                                                                Cancellation History
                                                                <Badge bg="danger" pill>{cancelCount}</Badge>
                                                            </span>
                                                            <span className="text-danger small d-flex align-items-center">
                                                                {isHistoryOpen ? <FaChevronUp /> : <FaChevronDown />}
                                                            </span>
                                                        </button>

                                                        {isHistoryOpen && (
                                                            <div className="px-3 pb-3">
                                                                <div
                                                                    style={{
                                                                        maxHeight: '220px',
                                                                        overflowY: visibleCancelledBookings.length > 3 ? 'auto' : 'visible'
                                                                    }}
                                                                >
                                                                    {visibleCancelledBookings.map((cb, idx) => (
                                                                        <div
                                                                            key={cb.id}
                                                                            className={`d-flex align-items-start gap-2 pt-2 ${idx > 0 ? 'border-top mt-2' : ''}`}
                                                                        >
                                                                            <span
                                                                                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger text-white flex-shrink-0"
                                                                                style={{ width: '20px', height: '20px', fontSize: '10px' }}
                                                                            >
                                                                                {cancelledBookings.length - idx}
                                                                            </span>
                                                                            <div className="small text-muted">
                                                                                <div className="text-dark">
                                                                                    Attempt #{cancelledBookings.length - idx} &mdash; Cancelled
                                                                                </div>
                                                                                <div style={{ fontSize: '11px' }}>
                                                                                    Applied on {formatDateTimeDisplay(cb.created_at)}
                                                                                </div>
                                                                                <div style={{ fontSize: '11px' }}>
                                                                                    Payment: {cb.paid_status || 'Unpaid'}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                {remainingHistoryCount > 0 ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-outline-danger w-100 mt-2 d-flex align-items-center justify-content-center gap-1"
                                                                        style={{ fontSize: '11px' }}
                                                                        onClick={() => setHistoryVisibleCount((prev) => ({
                                                                            ...prev,
                                                                            [keyId]: visibleHistoryCount + HISTORY_PAGE_SIZE
                                                                        }))}
                                                                    >
                                                                        <FaChevronDown />
                                                                        Load more ({remainingHistoryCount} more)
                                                                    </button>
                                                                ) : cancelCount > HISTORY_PAGE_SIZE ? (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-link w-100 mt-2 text-decoration-none text-muted d-flex align-items-center justify-content-center gap-1"
                                                                        style={{ fontSize: '11px' }}
                                                                        onClick={() => setHistoryVisibleCount((prev) => ({
                                                                            ...prev,
                                                                            [keyId]: HISTORY_PAGE_SIZE
                                                                        }))}
                                                                    >
                                                                        <FaChevronUp />
                                                                        Show less
                                                                    </button>
                                                                ) : null}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Application history - audit trail of this booking */}
                                                {isBookingActive && (
                                                    <div className="mb-3 rounded-3 border">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link w-100 text-decoration-none d-flex align-items-center justify-content-between gap-2 px-3 py-2"
                                                            onClick={() => toggleBookingAudit(keyId, booking.id)}
                                                            aria-expanded={expandedAudit === keyId}
                                                        >
                                                            <span className="d-flex align-items-center gap-2 text-secondary small fw-semibold">
                                                                <FaHistory />
                                                                Application History
                                                            </span>
                                                            <span className="text-secondary small d-flex align-items-center">
                                                                {expandedAudit === keyId ? <FaChevronUp /> : <FaChevronDown />}
                                                            </span>
                                                        </button>

                                                        {expandedAudit === keyId && (() => {
                                                            const auditState = bookingAudits[booking.id] || { loading: true, data: [] };
                                                            if (auditState.loading && auditState.data.length === 0) {
                                                                return (
                                                                    <div className="px-3 pb-3 text-center">
                                                                        <Spinner animation="border" size="sm" />
                                                                    </div>
                                                                );
                                                            }
                                                            if (auditState.error) {
                                                                return <div className="px-3 pb-3 small text-danger">Could not load history.</div>;
                                                            }
                                                            if (auditState.data.length === 0) {
                                                                return <div className="px-3 pb-3 small text-muted">No history available.</div>;
                                                            }
                                                            return (
                                                                <div className="px-3 pb-3" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                                                                    {auditState.data.map((audit, idx) => {
                                                                        const { label, variant } = describeAudit(audit);
                                                                        return (
                                                                            <div
                                                                                key={audit.audit_id}
                                                                                className={`d-flex align-items-start gap-2 pt-2 ${idx > 0 ? 'border-top mt-2' : ''}`}
                                                                            >
                                                                                <span
                                                                                    className={`rounded-circle bg-${variant} flex-shrink-0 mt-1`}
                                                                                    style={{ width: '10px', height: '10px' }}
                                                                                />
                                                                                <div className="small text-muted">
                                                                                    <div className="text-dark">{label}</div>
                                                                                    <div style={{ fontSize: '11px' }}>
                                                                                        {formatDateTimeDisplay(audit.action_at)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            );
                                                        })()}
                                                    </div>
                                                )}

                                                {/* Booking Status or Apply Button */}
                                                {isBookingActive ? (
                                                    <div className="mt-auto">
                                                        {/* Status Badges */}
                                                        <div className="d-flex gap-2 mb-3">
                                                            <Badge
                                                                bg={getStatusVariant(booking.status)}
                                                                className="d-flex align-items-center gap-1 flex-grow-1 justify-content-center py-2"
                                                            >
                                                                {booking.status === 'Approved' ? <FaCheckCircle /> : isRejected ? <FaTimesCircle /> : <FaClock />}
                                                                {booking.status}
                                                            </Badge>
                                                            <Badge
                                                                bg={getPaymentVariant(getEventPaidStatus(event, booking))}
                                                                className="d-flex align-items-center gap-1 flex-grow-1 justify-content-center py-2"
                                                            >
                                                                {getEventPaidStatus(event, booking) === 'paid' ? <FaCheckCircle /> : <FaClock />}
                                                                {getEventPaidStatus(event, booking)}
                                                            </Badge>
                                                            {booking.status === 'Pending' && getEventPaidStatus(event, booking) !== 'paid' && (
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => initiateCancelBooking(booking, event)}
                                                                    className="d-flex align-items-center justify-content-center gap-2"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            )}
                                                        </div>

                                                        {/* Action Buttons */}
                                                        <div className="d-grid gap-2">
                                                            {busInfo?.hasSubstitute && (
                                                                <div className="d-flex align-items-center flex-wrap gap-1 small text-muted">
                                                                    <FaBus className="text-warning flex-shrink-0" />
                                                                    <span>
                                                                        Substitute bus{' '}
                                                                        <strong className="text-dark">
                                                                            {busInfo.substitute?.vehicleNumber || '--'}
                                                                        </strong>
                                                                    </span>
                                                                    {busInfo.substitute?.hasTrip && (
                                                                        <Badge bg="light" text="dark" className="border" style={{ fontSize: '9px' }}>
                                                                            {busInfo.substitute.tripLabel}
                                                                        </Badge>
                                                                    )}
                                                                </div>
                                                            )}
                                                            {vehicleUrl && (
                                                                <Button
                                                                    variant={busInfo?.hasSubstitute ? "outline-warning" : "outline-primary"}
                                                                    size="sm"
                                                                    onClick={() => handleVehicleTrack(booking, event)}
                                                                    disabled={isRejected}
                                                                    className="d-flex align-items-center justify-content-center gap-2"
                                                                >
                                                                    <FaMapMarkerAlt />
                                                                    Track Vehicle
                                                                </Button>
                                                            )}
                                                            {getEventPaidStatus(event, booking) !== 'paid' && booking.status === 'Pending' && getEventDiscountAmount(booking) > 0 && (
                                                                <div className="small text-success text-center">
                                                                    Discount applied: −₹{getEventDiscountAmount(booking)}
                                                                </div>
                                                            )}
                                                            {getEventPaidStatus(event, booking) !== 'paid' && booking.status === 'Pending' ? (
                                                                <Button
                                                                    variant="primary"
                                                                    size="sm"
                                                                    onClick={() => handlePayNow(event, booking)}
                                                                    className="d-flex align-items-center justify-content-center gap-2"
                                                                >
                                                                    <FaRupeeSign />
                                                                    Pay ₹{getEventRemainingAmount(event, booking)}
                                                                </Button>
                                                            ) : booking.status === 'Approved' ? (
                                                                <>
                                                                    <Button
                                                                        variant="success"
                                                                        size="sm"
                                                                        onClick={() => handleCertificate(event.id, 'event')}
                                                                        className="d-flex align-items-center justify-content-center gap-2"
                                                                    >
                                                                        <FaCertificate />
                                                                        Event Certificate
                                                                    </Button>
                                                                    {booking.is_published && (
                                                                        <Button
                                                                            variant="info"
                                                                            size="sm"
                                                                            onClick={() => handleCertificate(event.id, 'achievement')}
                                                                            className="d-flex align-items-center justify-content-center gap-2"
                                                                        >
                                                                            <FaTrophy />
                                                                            Achievement Certificate
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            ) : isRejected ? (
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    disabled
                                                                    className="d-flex align-items-center justify-content-center gap-2"
                                                                >
                                                                    <FaTimesCircle />
                                                                    Application Rejected
                                                                </Button>
                                                            ) : (
                                                                <Alert variant="warning" className="p-2 small mb-0 text-center">
                                                                    {getEventRemainingAmount(event, booking) <= 0 ? "Application submitted. Awaiting approval." : "Payment received. Awaiting approval."}
                                                                </Alert>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : isRegistrationClosed ? (
                                                    <Button
                                                        variant="secondary"
                                                        disabled
                                                        className="w-100 py-2 d-flex align-items-center justify-content-center gap-2 mt-auto"
                                                    >
                                                        <FaTimesCircle />
                                                        Registration Closed
                                                    </Button>
                                                ) : (
                                                    <div className="mt-auto">
                                                        {hasCancelHistory && (
                                                            <div className="small text-muted mb-2 text-center">
                                                                You cancelled this event{' '}
                                                                <strong className="text-danger">
                                                                    {cancelCount} {cancelCount > 1 ? 'times' : 'time'}
                                                                </strong>
                                                                . You can apply again.
                                                            </div>
                                                        )}
                                                        <Button
                                                            variant={hasCancelHistory ? "success" : "primary"}
                                                            className="w-100 py-2 d-flex align-items-center justify-content-center gap-2"
                                                            onClick={() => {
                                                                setCurrentEventId(event.id);
                                                                setCurrentFeeCategoryId(event.fee_categories?.id || null);
                                                                setSelectedEvent(event);
                                                                setShowEventConfirmModal(true);
                                                            }}
                                                        >
                                                            {hasCancelHistory ? <FaRedo /> : <FaShieldAlt />}
                                                            {hasCancelHistory ? 'Apply Again' : 'Apply for Event'}
                                                            <FaArrowRight />
                                                        </Button>
                                                    </div>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>

                        {/* Pagination footer (Homework.js style) */}
                        {allDisplayItems.length > 0 && (
                            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3 mt-4 pt-3 mb-4 pb-4 border-top w-100">
                                <div className="text-secondary small text-center text-sm-start">
                                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, allDisplayItems.length)} of {allDisplayItems.length} entries
                                </div>

                                <div className="d-flex flex-wrap align-items-center justify-content-center gap-2">
                                    <nav aria-label="Page navigation" className="mb-0">
                                        <ul className="pagination pagination-sm mb-0" style={{ gap: '4px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    type="button"
                                                    className="page-link border-0 rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{ width: '32px', height: '32px', backgroundColor: '#f1f5f9', color: '#64748b' }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handlePageChange(currentPage - 1);
                                                    }}
                                                >
                                                    <FaChevronLeft style={{ fontSize: '10px' }} />
                                                </button>
                                            </li>
                                            {getPageNumbers().map((page) => (
                                                <li
                                                    key={page}
                                                    className={`page-item ${currentPage === page ? "active" : ""}`}
                                                >
                                                    <button
                                                        type="button"
                                                        className="page-link border-0 rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: '32px',
                                                            height: '32px',
                                                            backgroundColor: currentPage === page ? '#4f46e5' : '#f1f5f9',
                                                            color: currentPage === page ? '#ffffff' : '#64748b',
                                                            fontWeight: '600'
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handlePageChange(page);
                                                        }}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? "disabled" : ""}`}>
                                                <button
                                                    type="button"
                                                    className="page-link border-0 rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{ width: '32px', height: '32px', backgroundColor: '#f1f5f9', color: '#64748b' }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handlePageChange(currentPage + 1);
                                                    }}
                                                >
                                                    <FaChevronRight style={{ fontSize: '10px' }} />
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <Card className="border-0 shadow-sm text-center py-5">
                        <Card.Body>
                            <FaCalendarAlt className="text-muted fs-1 mb-3" />
                            <h5 className="text-muted">No {eventFilter === 'upcoming' ? 'Upcoming' : eventFilter === 'past' ? 'Past' : ''} Events Available</h5>
                            <p className="text-muted mb-4">Check back later or try changing filters for available events and activities.</p>
                            <Button
                                variant="outline-primary"
                                onClick={fetchEventData}
                                className="d-inline-flex align-items-center gap-2"
                            >
                                <FaCalendarAlt />
                                Refresh Events
                            </Button>
                        </Card.Body>
                    </Card>
                )}
            </Container>

            {/* Vehicle Tracking Modal */}
            <Modal
                show={isVehicleModalOpen}
                onHide={handleCloseVehicleView}
                size="lg"
                centered
            >
                <Modal.Header closeButton className="border-0 pb-2">
                    <Modal.Title className="d-flex align-items-center gap-2 text-primary">
                        <FaBus />
                        Vehicle Tracking
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className="mb-3">
                        <h5 className="fw-bold text-dark mb-1">
                            {activeVehicleBooking?.category?.title || activeVehicleEvent?.title || 'Selected Event'}
                        </h5>
                        {(activeVehicleBooking?.category?.event_location || activeVehicleEvent?.event_location) && (
                            <small className="text-muted d-flex align-items-center gap-1">
                                <FaMapMarkerAlt />
                                {activeVehicleBooking?.category?.event_location || activeVehicleEvent?.event_location}
                            </small>
                        )}
                    </div>

                    {isTrackingTimeAllowed(activeVehicleBooking, activeVehicleEvent) ? (
                        <>
                            <EventBusArrivingCard info={activeVehicleBusInfo} />

                            {vehicleOptions.length > 0 ? (
                                <>
                                    {vehicleOptions.length > 1 && (
                                        <Form.Group className="mb-3 p-3 bg-light rounded-3 border">
                                            <Form.Label className="fw-semibold d-block mb-2 text-dark">Select Vehicle</Form.Label>
                                            <div className="d-flex flex-wrap gap-3">
                                                {vehicleOptions.map((opt, idx) => (
                                                    <div key={idx} className="form-check form-check-inline d-flex align-items-center mb-0">
                                                        <input
                                                            type="radio"
                                                            className="form-check-input"
                                                            name="eventVehicleTrackRadioEvent"
                                                            id={`eventVehicleTrackRadioEvent_${idx}`}
                                                            value={opt.value}
                                                            checked={selectedVehicleUrl === opt.value}
                                                            onChange={(e) => setSelectedVehicleUrl(e.target.value)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                        <label
                                                            className="form-check-label ms-2 fw-medium text-dark"
                                                            htmlFor={`eventVehicleTrackRadioEvent_${idx}`}
                                                            style={{ cursor: 'pointer', fontSize: '13px' }}
                                                        >
                                                            {opt.label}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </Form.Group>
                                    )}

                                    {selectedVehicleUrl ? (
                                        <div className="border rounded-3 overflow-hidden shadow-sm">
                                            <iframe
                                                src={selectedVehicleUrl}
                                                width="100%"
                                                height="420"
                                                style={{ border: 'none' }}
                                                title="Vehicle Tracking Map"
                                            />
                                        </div>
                                    ) : (
                                        <Alert variant="info" className="text-center py-4 my-2">
                                            <FaMapMarkerAlt className="fs-1 mb-2" />
                                            <p className="mb-0">
                                                Select a vehicle to start tracking.
                                            </p>
                                        </Alert>
                                    )}
                                </>
                            ) : (
                                <Alert variant="warning" className="text-center py-4 my-2">
                                    <FaBus className="fs-1 mb-2" />
                                    <p className="mb-0">
                                        {activeVehicleBusInfo?.hasSubstitute
                                            ? `Live tracking link for substitute vehicle ${activeVehicleBusInfo?.substitute?.vehicleNumber || ''} has not been shared by school admin yet.`
                                            : 'No vehicle tracking details available for this event booking.'}
                                    </p>
                                </Alert>
                            )}

                            <EventBusContactCard info={activeVehicleBusInfo} />
                        </>
                    ) : (
                        <Alert variant="warning" className="text-center py-4 my-3 rounded-3 shadow-sm border-warning">
                            <FaClock className="fs-1 text-warning mb-2" />
                            <h5 className="fw-bold text-dark">Vehicle Tracking Unavailable</h5>
                            <p className="mb-0 text-muted small">
                                Tracking is only active between event dates: <br />
                                <span className="fw-bold text-dark">
                                    {formatDateDisplay(activeVehicleBooking?.category?.start_date || activeVehicleEvent?.start_date)}
                                </span>
                                {' '}to{' '}
                                <span className="fw-bold text-dark">
                                    {formatDateDisplay(activeVehicleBooking?.category?.end_date || activeVehicleEvent?.end_date || activeVehicleBooking?.category?.due_date || activeVehicleEvent?.due_date)}
                                </span>.
                            </p>
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <Button variant="secondary" className="px-4" onClick={handleCloseVehicleView}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* OTP Verification Modal */}
            <Modal
                show={showOtpModal}
                onHide={() => setShowOtpModal(false)}
                centered
                backdrop="static"
            >
                <div className="otp-modal-content p-4 rounded-4 bg-white position-relative overflow-hidden border-0">
                    {/* Header decoration accent */}
                    <div
                        className="position-absolute top-0 start-0 w-100"
                        style={{
                            height: '6px',
                            background: 'linear-gradient(90deg, #4f46e5 0%, #06b6d4 100%)'
                        }}
                    />

                    <div className="text-end mb-1">
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowOtpModal(false)}
                        />
                    </div>

                    <div className="text-center mb-4">
                        <div
                            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 p-3"
                            style={{
                                background: 'rgba(79, 70, 229, 0.08)',
                                color: '#4f46e5',
                                width: '68px',
                                height: '68px',
                                boxShadow: '0 0 20px rgba(79, 70, 229, 0.12)'
                            }}
                        >
                            <FaShieldAlt style={{ fontSize: '32px' }} />
                        </div>
                        <h4 className="fw-bold text-dark mb-1">Verify Security OTP</h4>
                        <p className="text-muted small mb-0 px-2">
                            We have sent a 6-digit verification code to your registered contact details.
                        </p>
                        {(studentMobileNo || studentEmail) && (
                            <div className="mt-2">
                                <Badge bg="light" text="dark" className="border px-3 py-2 rounded-pill fw-normal small">
                                    <FaMobileAlt className="me-1 text-primary" />
                                    {studentMobileNo ? `******${String(studentMobileNo).slice(-4)}` : studentEmail}
                                </Badge>
                            </div>
                        )}
                    </div>

                    {/* 6 Digit OTP Input Boxes */}
                    <div className="d-flex justify-content-center gap-2 mb-4" onPaste={handleOtpPaste}>
                        {otpDigits.map((digit, idx) => (
                            <input
                                key={idx}
                                id={`otp-input-${idx}`}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleOtpDigitChange(idx, e.target.value)}
                                onKeyDown={(e) => handleOtpKeyDown(idx, e)}
                                className="form-control text-center fw-bold fs-4 otp-digit-box"
                                style={{
                                    width: '46px',
                                    height: '54px',
                                    borderRadius: '12px',
                                    border: digit ? '2px solid #4f46e5' : '2px solid #e2e8f0',
                                    backgroundColor: digit ? '#f8fafc' : '#ffffff',
                                    boxShadow: digit ? '0 0 0 3px rgba(79, 70, 229, 0.1)' : 'none',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                                autoFocus={idx === 0}
                            />
                        ))}
                    </div>

                    {/* Timer & Resend Option */}
                    <div className="text-center mb-4">
                        {isResendDisabled ? (
                            <div className="d-inline-flex align-items-center gap-2 text-muted small bg-light px-3 py-2 rounded-pill border">
                                <FaClock className="text-primary" />
                                <span>Resend OTP in <strong className="text-dark">{formatTimer(resendTimer)}</strong></span>
                            </div>
                        ) : (
                            <Button
                                variant="link"
                                size="sm"
                                onClick={sendOtp}
                                className="text-decoration-none fw-semibold text-primary d-inline-flex align-items-center gap-1"
                            >
                                <FaMobileAlt /> Resend Verification Code
                            </Button>
                        )}
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex gap-2">
                        <Button
                            variant="light"
                            className="w-50 py-2 rounded-3 fw-semibold border"
                            onClick={() => setShowOtpModal(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={() => verifyOtp()}
                            disabled={otpLoading || otpDigits.join('').length !== 6}
                            className="w-50 py-2 rounded-3 fw-semibold d-flex align-items-center justify-content-center gap-2 shadow-sm"
                            style={{
                                background: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)',
                                border: 'none'
                            }}
                        >
                            {otpLoading ? (
                                <>
                                    <Spinner animation="border" size="sm" />
                                    Verifying...
                                </>
                            ) : (
                                <>
                                    <FaCheckCircle />
                                    Verify & Apply
                                </>
                            )}
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Certificate Modal */}
            <Modal show={showCertModal} onHide={() => setShowCertModal(false)} size="xl" centered className="cert-modal-responsive">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="d-flex align-items-center gap-2">
                        <FaCertificate className="text-primary" />
                        {certType === 'event' ? 'Event Participation' : 'Achievement'} Certificate
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0 overflow-auto" style={{ maxHeight: '75vh', minHeight: '300px' }}>
                    <div className="cert-content-container" dangerouslySetInnerHTML={{ __html: certHtml }} />
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button
                        variant="primary"
                        onClick={printCertificate}
                        className="d-flex align-items-center gap-2"
                    >
                        <FaPrint />
                        Print Certificate
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showImageModal}
                onHide={() => setShowImageModal(false)}
                centered
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Event Image</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center p-2">
                    <img
                        src={selectedImage}
                        alt="Event"
                        style={{
                            width: "100%",
                            maxHeight: "80vh",
                            objectFit: "contain",
                        }}
                        onError={(e) => {
                            e.target.src =
                                "https://via.placeholder.com/600x400/f8f9fa/6c757d?text=Event+Image";
                        }}
                    />
                </Modal.Body>
            </Modal>

            {/* Event Participation Confirmation Modal */}
            <Modal
                show={showEventConfirmModal}
                onHide={() => setShowEventConfirmModal(false)}
                centered
            >
                <Modal.Header closeButton className="border-0 pb-2">
                    <Modal.Title className="fw-bold text-dark">
                        {selectedEventCancelCount > 0 ? "Re-apply for Event" : "Confirm Event Participation"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-2">
                    <div className="text-center mb-3">
                        <div
                            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                            style={{
                                width: "64px",
                                height: "64px",
                                background: "rgba(79, 70, 229, 0.08)",
                                color: "#4f46e5"
                            }}
                        >
                            {selectedEventCancelCount > 0
                                ? <FaRedo style={{ fontSize: "26px" }} />
                                : <FaCalendarAlt style={{ fontSize: "28px" }} />}
                        </div>
                    </div>

                    <p className="text-dark mb-3 text-center">
                        You are registering your child for{" "}
                        <strong>{selectedEvent?.title || "Selected Event"}</strong>
                    </p>

                    {selectedEventCancelCount > 0 && (
                        <Alert variant="warning" className="d-flex align-items-start gap-2 small py-2 px-3">
                            <FaExclamationTriangle className="flex-shrink-0 mt-1" />
                            <span>
                                You had cancelled this event{" "}
                                <strong>
                                    {selectedEventCancelCount} {selectedEventCancelCount > 1 ? "times" : "time"}
                                </strong>{" "}
                                before. A fresh booking will be created on proceeding.
                            </span>
                        </Alert>
                    )}

                    <div className="bg-light border rounded-3 p-3 mb-3">
                        <p className="mb-0 text-muted">
                            By proceeding, you agree to pay the event fee of{" "}
                            <strong className="text-dark">
                                ₹{getEventPayAmount(selectedEvent || {})}
                            </strong>, which will be
                            added to your child’s outstanding fees.
                        </p>
                    </div>

                    <p className="text-dark fw-semibold text-center mb-1">
                        Would you like to proceed?
                    </p>
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    <Button
                        variant="light"
                        className="px-4 rounded-3 fw-semibold border me-2"
                        onClick={() => setShowEventConfirmModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        className="px-4 rounded-3 fw-semibold d-flex align-items-center gap-2"
                        onClick={handleAgreeAndProceed}
                    >
                        <FaCheckCircle />
                        Agree & Proceed
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Custom Cancel Event Booking Confirmation Modal */}
            <Modal
                show={showCancelConfirmModal}
                onHide={() => !cancellingLoading && setShowCancelConfirmModal(false)}
                centered
            >
                <Modal.Header closeButton className="border-0 pb-2">
                    <Modal.Title className="fw-bold text-dark">
                        Cancel Event Booking
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-2 text-center">
                    <div className="mb-3">
                        <div
                            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-2"
                            style={{
                                width: "64px",
                                height: "64px",
                                background: "rgba(220, 53, 69, 0.1)",
                                color: "#dc3545"
                            }}
                        >
                            <FaExclamationTriangle style={{ fontSize: "28px" }} />
                        </div>
                    </div>

                    <h5 className="fw-bold text-dark mb-2">Are you sure?</h5>
                    <p className="text-muted mb-0">
                        Do you really want to cancel this event booking?
                    </p>
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0 justify-content-center gap-2">
                    <Button
                        variant="light"
                        className="px-4 rounded-3 fw-semibold border"
                        onClick={() => setShowCancelConfirmModal(false)}
                        disabled={cancellingLoading}
                    >
                        No, Keep It
                    </Button>

                    <Button
                        variant="danger"
                        className="px-4 rounded-3 fw-semibold d-flex align-items-center gap-2"
                        onClick={confirmCancelBooking}
                        disabled={cancellingLoading}
                    >
                        {cancellingLoading ? (
                            <>
                                <Spinner animation="border" size="sm" />
                                Cancelling...
                            </>
                        ) : (
                            "Yes, Cancel Booking"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Custom Styles */}
            <style jsx>{`
                .hover-lift:hover {
                    transform: translateY(-5px);
                    transition: all 0.3s ease;
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
                }
                .otp-digit-box:focus {
                    border-color: #4f46e5 !important;
                    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.2) !important;
                    outline: none !important;
                }
                .cert-content-container {
                    width: 100%;
                    overflow-x: auto;
                    -webkit-overflow-scrolling: touch;
                }
                .cert-content-container table,
                .cert-content-container div,
                .cert-content-container img {
                    max-width: 100% !important;
                    box-sizing: border-box;
                }
                @media (max-width: 576px) {
                    .cert-modal-responsive .modal-dialog {
                        margin: 0.5rem;
                        max-width: calc(100% - 1rem) !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default Event;
